unit settings.useraccesssetup;

interface

uses
  System.SysUtils, System.Classes, System.Types, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.DBCtrls, Vcl.Grids, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client, WEBLib.Grids, WEBLib.DB, Types,
  VCL.TMSFNCTypes, VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
  System.Rtti, VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData,
  VCL.TMSFNCDataGridBase, VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer,
  VCL.TMSFNCCustomComponent, VCL.TMSFNCDataGridDatabaseAdapter,
  VCL.TMSFNCCustomControl, VCL.TMSFNCDataGrid, VCL.TMSFNCBitmapContainer,
  WEBLib.Buttons;

type
  TfrmUserAccessSetup = class(TForm)
    wpMain: TPanel;
    WebScrollBox1: TScrollBox;
    WebPanel1: TPanel;
    WebLabel1: TLabel;
    WebPanel2: TPanel;
    btnClose: TButton;
    WebPanel3: TPanel;
    WebScrollBox3: TScrollBox;
    edtUserCode: TDBEdit;
    edtUserName: TDBEdit;
    edtPassword: TDBEdit;
    btnGenPassword: TButton;
    wcAccess: TXDataWebClient;
    qAccess: TXDataWebDataSet;
    dsAccess: TDataSource;
    btnCopyRights: TButton;
    edtCellNo: TDBEdit;
    edtEmail: TDBEdit;
    WebDBCheckBox1: TDBCheckBox;
    wdblSites: TDBLookupComboBox;
    WebDBCheckBox2: TDBCheckBox;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    WebLabel7: TLabel;
    WebLabel8: TLabel;
    btnCancel: TButton;
    btnSave: TButton;
    WebMessageDlg1: TMessageDlg;
    qSites: TXDataWebDataSet;
    dsSites: TDataSource;
    TMSFNCDataGrid1: TTMSFNCDataGrid;
    dgdbaUserAccess: TTMSFNCDataGridDatabaseAdapter;
    wcUser: TXDataWebClient;
    wdsUser: TXDataWebDataSet;
    dsUser: TDataSource;
    qAccessUserCode: TStringField;
    qAccessRightName: TStringField;
    qAccessAccess: TStringField;
    BitmapContainer1: TTMSFNCBitmapContainer;
    wdsUsertemp: TStringField;
    qSitesTemp: TStringField;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton3: TSpeedButton;
    WebSpeedButton4: TSpeedButton;
    edtSearchAccess: TEdit;
    WebLabel2: TLabel;
    qAccessModified: TBooleanField;
    procedure btnCloseClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure qUserAfterOpen(DataSet: TDataSet);
    procedure qAccessAfterOpen(DataSet: TDataSet);
    procedure btnCancelClick(Sender: TObject);
    procedure grdMainClickCell(Sender: TObject; ACol, ARow: Integer);
   // procedure grdAccessRightsCanEditCell(Sender: TObject; ACol, ARow: Integer;
   //   var CanEdit: Boolean);
    procedure grdAccessRightsClickCell(Sender: TObject; ACol, ARow: Integer);
    procedure btnSaveClick(Sender: TObject);
    procedure btnGenPasswordClick(Sender: TObject);
    procedure btnCopyRightsClick(Sender: TObject);
    procedure TMSFNCDataGrid1GetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure TMSFNCDataGrid1CellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure WebSpeedButton2Click(Sender: TObject);
    procedure WebSpeedButton3Click(Sender: TObject);
    procedure WebSpeedButton4Click(Sender: TObject);
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure edtSearchAccessChange(Sender: TObject);
  private
    { Private declarations }
    procedure DoPostData;

    procedure LoadUserAccess(sUserCode : string);

  public
    { Public declarations }

    iState : Integer;
    iLastActiveRecord : Integer;

    sUser : String;
    bAppend, bExistingUser : Boolean;
  protected procedure LoadDFMValues; override; end;

var
  frmUserAccessSetup: TfrmUserAccessSetup;

implementation

{$R *.dfm}

uses
  stfmssystem.connection, settings.usercopyrights, share.common;

procedure TfrmUserAccessSetup.DoPostData;
 // procedure OnError(Error: TXDataClientError);
 // begin
 //  WebMessageDlg1.ShowDialog('An Error was encountered while Saving the Access Rights.' + sLineBreak +
 //                            Error.ErrorMessage, mtError, [mbOk]);
 //  //Abort;
 // end;
begin
 {try
   qUser.Post;
   qUser.ApplyUpdates;
 except
   on Error : Exception do
     begin
       WebMessageDlg1.ShowDialog('An Error was encountered while Saving the User Details.' + sLineBreak +
                                  Error.Message, mtError, [mbOk]);
       //Abort;
     end;
 end;
 try
   webclient.RawInvoke('IstfmsSystemService.PutUserAccess', [Trim(edtUserCode.Text), qAccess.CurrentData], nil, @OnError);
 except
   on Error : Exception do
     begin
       WebMessageDlg1.ShowDialog('An Error was encountered while Saving the Access Rights.' + #13#10 +
                                  Error.Message, mtError, [mbOk]);
       Exit; //Abort;
     end;
 end;
 ShowMessage('Post SuccessFull!!!');  }
end;

procedure TfrmUserAccessSetup.qAccessAfterOpen(DataSet: TDataSet);
//  var sList : TStringList;
//      sCat : String;
//      iCntr : Integer;
begin
  {if qAccess.RecordCount > 0 then
   begin
    sList := TStringList.Create;
    sList.Sorted := True;
    sList.Duplicates := dupIgnore;
    qAccess.First;
    while not qAccess.Eof do
     begin
      sCat := qAccess.FieldByName('MainCat').AsString;
      sList.Add(sCat);
      qAccess.Next;
     end;
    grdMain.Cells[0,0] := 'Main Category';
    grdMain.RowCount := 1;
    for iCntr := 0 to sList.Count - 1 do
     begin
      sCat := sList[iCntr];
      grdMain.RowCount := iCntr + 2;
      grdMain.Cells[0,iCntr + 1] := sCat;
     end;
    grdMain.Row := 1;
    sList.Clear;
    sList.Free;
   end;  }
end;

procedure TfrmUserAccessSetup.qUserAfterOpen(DataSet: TDataSet);
begin
 // if bAppend then
 //   qUser.Append
 // else
 //   qUser.Edit;
end;

procedure TfrmUserAccessSetup.TMSFNCDataGrid1CellClick(Sender: TObject; AColumn,
  ARow: Integer);
begin
  iLastActiveRecord := ARow;

  if AColumn = 3 then
    Begin
      dgdbaUserAccess.SetActiveRecord(ARow);

      iLastActiveRecord := ARow;

       qAccess.Edit;

      if qAccess.FieldByName('Access').AsString = 'Y' then
        Begin
          qAccess.FieldByName('Modified').AsBoolean := True;
          qAccess.FieldByName('Access').AsString := 'N';
        End
      else
        Begin
          qAccess.FieldByName('Modified').AsBoolean := True;
          qAccess.FieldByName('Access').AsString := 'Y';
        End;

      qAccess.Post;

    End;

end;

procedure TfrmUserAccessSetup.TMSFNCDataGrid1GetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
  if ACell.IsBitmapCell and dgdbaUserAccess.IsValidDataCell(ACell.Coordinate) then
    begin
      if ACell.Column = 3 then
        Begin

           iLastActiveRecord := qAccess.RecNo;

          dgdbaUserAccess.SetActiveRecord(ACell.Row);

          if dgdbaUserAccess.FieldAtColumn[2].AsString = 'Y' then
            ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[0]
          else
            ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[1];

          dgdbaUserAccess.SetActiveRecord(iLastActiveRecord);
        End;
    end;
end;

procedure TfrmUserAccessSetup.grdMainClickCell(Sender: TObject; ACol,
  ARow: Integer);
  //var sCat : String;
begin
  //if ARow = 0
  // then Exit;

  //sCat := grdMain.Cells[0,ARow];
  //qAccess.Filtered := False;
  //qAccess.Filter := 'MainCat = ' + QuotedStr(sCat);
  //qAccess.Filtered := True;
  {qAccess.Close;
  qAccess.QueryString := '$filter=MainCat eq ' + QuotedStr(sCat);
  qAccess.Load;}
end;

procedure TfrmUserAccessSetup.LoadUserAccess(sUserCode: string);
var
  sJson : String;

  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
    end;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      qAccess.Close;
      qAccess.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      qAccess.Open;

      console.log(GetJsonFromDataSet(qAccess));
    end;
begin

  sJson := '{"usercode":"' + sUserCode + '"}';

  wcAccess.RawInvoke('IstfmsSystemService.Get_UserAccess_View',[sJson],@OnSuccess,@OnError);
end;

procedure TfrmUserAccessSetup.btnCloseClick(Sender: TObject);
begin
  Close;
end;

procedure TfrmUserAccessSetup.btnGenPasswordClick(Sender: TObject);
begin
 edtPassword.Text := GeneratePassword(10, [pmLower, pmUpper, pmNumbers, pmExtra]);
end;

procedure TfrmUserAccessSetup.btnCancelClick(Sender: TObject);
  //procedure OnResult(Response : TXDataClientResponse);
  //begin
 //   qAccess.Close;
 //   qAccess.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
  //  qAccess.Open;
  //end;
begin
 //if qUser.State in [dsEdit]
 // then qUser.Cancel;
 //webclient.RawInvoke('IstfmsSystemService.GetUserAccess', [sUser], @OnResult);
end;

procedure TfrmUserAccessSetup.btnSaveClick(Sender: TObject);
  procedure OnError(Error: TXDataClientError);
  begin
    ShowMessage('Error Upadting User Rights!');
  end;

  procedure OnSuccess(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        ShowMessage('Error Upadting User Rights!');
      end
    else
      begin
        ShowMessage('Successfully Upadated User Rights!');
      end;
  end;
begin

  console.log(GetJsonArrayFromDataSet(qAccess,True,'Modified'));

  wcAccess.RawInvoke('IstfmsSystemService.Put_UserAccess_Edit',[GetJsonArrayFromDataSet(qAccess,True,'Modified')],@OnSuccess,@OnError);



 { if edtUserName.Text = '' then
   begin
    WebMessageDlg1.ShowDialog('User Name must have A Value', mtError, [mbOk]);
    edtUserName.Setfocus;
    Exit;
   end;
  if edtEmail.Text = '' then
   begin
    WebMessageDlg1.ShowDialog('E-Mail Address must have A Value', mtError, [mbOk]);
    edtEmail.Setfocus;
    Exit;
   end;
  if qUser.State in [dsInsert] then
   begin
    if Trim(edtUserCode.Text) = '' then
      begin
        WebMessageDlg1.ShowDialog('User Code must have A Value', mtError, [mbOk]);
        edtUserCode.Setfocus;
        exit;
      end;
    //ValidateUserCode;
    q := TXDataWebDataSet.Create(nil);
    q.Connection := dmdata.dbConnect;
    q.EntitySetName := 'workemail';
    q.QueryString := '$filter=slncode eq' + QuotedStr(Trim(edtUserCode.Text));
    q.AfterOpen := AfterOpen;
    q.Load;
   end
  else
   begin
    DoPostData;
    ShowMessage('Post SuccessFull!');
   end;
end;

procedure TfrmUserAccessSetup.grdAccessRightsCanEditCell(Sender: TObject; ACol,
  ARow: Integer; var CanEdit: Boolean);
begin
 CanEdit := False;
 if ARow >= 1 then
  begin
   if ACol = 1
    then CanEdit := True;
  end;  }
end;

procedure TfrmUserAccessSetup.grdAccessRightsClickCell(Sender: TObject; ACol,
  ARow: Integer);
begin
 // if Acol = 2 then
 //   begin
      {qAccess.First;
      qAccess.MoveBy(ARow - 1); }
   //   qAccess.Edit;
   //   qAccess.FieldByName('Data').AsBoolean := not qAccess.FieldByName('Data').AsBoolean;
      {if qAccess.FieldByName('Data').AsBoolean then
        qAccess.FieldByName('Data').AsBoolean := False
      else
        qAccess.FieldByName('Data').AsBoolean := True;    }
    //  qAccess.Post;
    //end;
end;

procedure TfrmUserAccessSetup.btnCopyRightsClick(Sender: TObject);
//var
 // LFrm : TfrmUserCopyRights;
 { procedure AfterCreate(AForm : TObject);
   begin
    with (AForm as TfrmUserCopyRights) do
     begin
      sUser := qUser.FieldByName('slncode').asString;
      //qUsers.Close;
      qUsers.QueryString := '$filter=slncode ne ' + quotedstr(sUser) + ' & ' +
                            'suspended eq ''N'' & order SLNNAME';
      qUsers.Load;
      btnCopySelected := False;
     end;
    end;
  procedure AfterShoWModal(AValue: TModalResult);
   begin
    qUser.Close;
    qUser.Load;
   end;        }
begin
{ LFrm :=  TfrmUserCopyRights.CreateNew(@AfterCreate);
 // LFrm als Pop-Up festlegen
 LFrm.Popup := true;

 // Transparenz definieren
 LFrm.PopupOpacity := 0.2;
 LFrm.ShowModal(@AfterShowModal);    }
end;

procedure TfrmUserAccessSetup.edtSearchAccessChange(Sender: TObject);
begin
  qAccess.Locate('RightName',edtSearchAccess.Text,[loCaseInsensitive,loPartialKey])
end;

procedure TfrmUserAccessSetup.WebFormShow(Sender: TObject);
{  procedure OnResult(Response : TXDataClientResponse);
  begin
    qAccess.Close;
    qAccess.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
    qAccess.Open;
  end;      }
begin

  LoadUserAccess(sUser);

  iLastActiveRecord := 1;

{  webclient.RawInvoke('IstfmsSystemService.GetUserAccess', [sUser], @OnResult);
  qUser.Close;
  qUser.QueryString := '$filter=slncode eq ' + quotedstr(sUser);
  qUser.Load;
  qSites.Close;
  qSites.Load;
  bExistingUser := False;
  edtUserCode.ReadOnly := not bAppend;
  wdblSites.Height := edtEmail.Height;
  btnGenPassword.Top := edtPassword.Top;
  btnGenPassword.Height := edtPassword.Height;    }
end;

procedure TfrmUserAccessSetup.WebSpeedButton1Click(Sender: TObject);
begin
  qAccess.First;
end;

procedure TfrmUserAccessSetup.WebSpeedButton2Click(Sender: TObject);
begin
  qAccess.prior;
end;

procedure TfrmUserAccessSetup.WebSpeedButton3Click(Sender: TObject);
begin
  qAccess.Next;
end;

procedure TfrmUserAccessSetup.WebSpeedButton4Click(Sender: TObject);
begin
  qAccess.Last;
end;

procedure TfrmUserAccessSetup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  wpMain := TPanel.Create(Self);
  WebScrollBox1 := TScrollBox.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  edtUserCode := TDBEdit.Create(Self);
  edtUserName := TDBEdit.Create(Self);
  edtPassword := TDBEdit.Create(Self);
  btnGenPassword := TButton.Create(Self);
  btnCopyRights := TButton.Create(Self);
  edtCellNo := TDBEdit.Create(Self);
  edtEmail := TDBEdit.Create(Self);
  WebDBCheckBox1 := TDBCheckBox.Create(Self);
  wdblSites := TDBLookupComboBox.Create(Self);
  WebDBCheckBox2 := TDBCheckBox.Create(Self);
  WebMessageDlg1 := TMessageDlg.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  edtSearchAccess := TEdit.Create(Self);
  WebScrollBox3 := TScrollBox.Create(Self);
  TMSFNCDataGrid1 := TTMSFNCDataGrid.Create(Self);
  dgdbaUserAccess := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  BitmapContainer1 := TTMSFNCBitmapContainer.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  btnClose := TButton.Create(Self);
  btnCancel := TButton.Create(Self);
  btnSave := TButton.Create(Self);
  wcAccess := TXDataWebClient.Create(Self);
  qAccess := TXDataWebDataSet.Create(Self);
  qAccessUserCode := TStringField.Create(Self);
  qAccessRightName := TStringField.Create(Self);
  qAccessAccess := TStringField.Create(Self);
  qAccessModified := TBooleanField.Create(Self);
  dsAccess := TDataSource.Create(Self);
  qSites := TXDataWebDataSet.Create(Self);
  qSitesTemp := TStringField.Create(Self);
  dsSites := TDataSource.Create(Self);
  wcUser := TXDataWebClient.Create(Self);
  wdsUser := TXDataWebDataSet.Create(Self);
  wdsUsertemp := TStringField.Create(Self);
  dsUser := TDataSource.Create(Self);

  wpMain.BeforeLoadDFMValues;
  WebScrollBox1.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  edtUserCode.BeforeLoadDFMValues;
  edtUserName.BeforeLoadDFMValues;
  edtPassword.BeforeLoadDFMValues;
  btnGenPassword.BeforeLoadDFMValues;
  btnCopyRights.BeforeLoadDFMValues;
  edtCellNo.BeforeLoadDFMValues;
  edtEmail.BeforeLoadDFMValues;
  WebDBCheckBox1.BeforeLoadDFMValues;
  wdblSites.BeforeLoadDFMValues;
  WebDBCheckBox2.BeforeLoadDFMValues;
  WebMessageDlg1.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  edtSearchAccess.BeforeLoadDFMValues;
  WebScrollBox3.BeforeLoadDFMValues;
  TMSFNCDataGrid1.BeforeLoadDFMValues;
  dgdbaUserAccess.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  BitmapContainer1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  btnClose.BeforeLoadDFMValues;
  btnCancel.BeforeLoadDFMValues;
  btnSave.BeforeLoadDFMValues;
  wcAccess.BeforeLoadDFMValues;
  qAccess.BeforeLoadDFMValues;
  qAccessUserCode.BeforeLoadDFMValues;
  qAccessRightName.BeforeLoadDFMValues;
  qAccessAccess.BeforeLoadDFMValues;
  qAccessModified.BeforeLoadDFMValues;
  dsAccess.BeforeLoadDFMValues;
  qSites.BeforeLoadDFMValues;
  qSitesTemp.BeforeLoadDFMValues;
  dsSites.BeforeLoadDFMValues;
  wcUser.BeforeLoadDFMValues;
  wdsUser.BeforeLoadDFMValues;
  wdsUsertemp.BeforeLoadDFMValues;
  dsUser.BeforeLoadDFMValues;
  try
    Name := 'frmUserAccessSetup';
    Width := 836;
    Height := 617;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    wpMain.SetParentComponent(Self);
    wpMain.Name := 'wpMain';
    wpMain.Left := 0;
    wpMain.Top := 0;
    wpMain.Width := 836;
    wpMain.Height := 617;
    wpMain.ElementClassName := 'card';
    wpMain.Align := alClient;
    wpMain.ElementBodyClassName := 'card-body';
    wpMain.ElementFont := efCSS;
    wpMain.TabOrder := 0;
    WebScrollBox1.SetParentComponent(wpMain);
    WebScrollBox1.Name := 'WebScrollBox1';
    WebScrollBox1.Left := 0;
    WebScrollBox1.Top := 33;
    WebScrollBox1.Width := 836;
    WebScrollBox1.Height := 519;
    WebScrollBox1.ElementClassName := 'card';
    WebScrollBox1.Align := alClient;
    WebScrollBox1.BorderStyle := bsSingle;
    WebScrollBox1.ChildOrder := 2;
    WebPanel3.SetParentComponent(WebScrollBox1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 0;
    WebPanel3.Width := 836;
    WebPanel3.Height := 217;
    WebPanel3.ElementClassName := 'card';
    WebPanel3.Align := alTop;
    WebPanel3.ElementBodyClassName := 'card-body';
    WebPanel3.ElementFont := efCSS;
    WebPanel3.TabOrder := 0;
    WebLabel3.SetParentComponent(WebPanel3);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 3;
    WebLabel3.Top := 6;
    WebLabel3.Width := 59;
    WebLabel3.Height := 16;
    WebLabel3.Caption := 'User Code';
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -13;
    WebLabel3.Font.Name := 'Tahoma';
    WebLabel3.Font.Style := [];
    WebLabel3.HeightStyle := ssAuto;
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel3);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 130;
    WebLabel4.Top := 6;
    WebLabel4.Width := 63;
    WebLabel4.Height := 16;
    WebLabel4.Caption := 'User Name';
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clWindowText;
    WebLabel4.Font.Height := -13;
    WebLabel4.Font.Name := 'Tahoma';
    WebLabel4.Font.Style := [];
    WebLabel4.HeightStyle := ssAuto;
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.ParentFont := False;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel3);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 503;
    WebLabel5.Top := 6;
    WebLabel5.Width := 55;
    WebLabel5.Height := 16;
    WebLabel5.Caption := 'Password';
    WebLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLabel5.Font.Color := clWindowText;
    WebLabel5.Font.Height := -13;
    WebLabel5.Font.Name := 'Tahoma';
    WebLabel5.Font.Style := [];
    WebLabel5.HeightStyle := ssAuto;
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.ParentFont := False;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(WebPanel3);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 3;
    WebLabel6.Top := 79;
    WebLabel6.Width := 70;
    WebLabel6.Height := 16;
    WebLabel6.Caption := 'Cell Number';
    WebLabel6.Font.Charset := DEFAULT_CHARSET;
    WebLabel6.Font.Color := clWindowText;
    WebLabel6.Font.Height := -13;
    WebLabel6.Font.Name := 'Tahoma';
    WebLabel6.Font.Style := [];
    WebLabel6.HeightStyle := ssAuto;
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.ParentFont := False;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(WebPanel3);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 130;
    WebLabel7.Top := 79;
    WebLabel7.Width := 35;
    WebLabel7.Height := 16;
    WebLabel7.Caption := 'E-Mail';
    WebLabel7.Font.Charset := DEFAULT_CHARSET;
    WebLabel7.Font.Color := clWindowText;
    WebLabel7.Font.Height := -13;
    WebLabel7.Font.Name := 'Tahoma';
    WebLabel7.Font.Style := [];
    WebLabel7.HeightStyle := ssAuto;
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.ParentFont := False;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel8.SetParentComponent(WebPanel3);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 503;
    WebLabel8.Top := 79;
    WebLabel8.Width := 22;
    WebLabel8.Height := 16;
    WebLabel8.Caption := 'Site';
    WebLabel8.Font.Charset := DEFAULT_CHARSET;
    WebLabel8.Font.Color := clWindowText;
    WebLabel8.Font.Height := -13;
    WebLabel8.Font.Name := 'Tahoma';
    WebLabel8.Font.Style := [];
    WebLabel8.HeightStyle := ssAuto;
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.ParentFont := False;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel3);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 10;
    WebLabel2.Top := 168;
    WebLabel2.Width := 110;
    WebLabel2.Height := 14;
    WebLabel2.Caption := 'Search Access Right';
    WebLabel2.ElementFont := efCSS;
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clWindowText;
    WebLabel2.Font.Height := -12;
    WebLabel2.Font.Name := 'Tahoma';
    WebLabel2.Font.Style := [];
    WebLabel2.HeightStyle := ssAuto;
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.WidthPercent := 100.000000000000000000;
    edtUserCode.SetParentComponent(WebPanel3);
    edtUserCode.Name := 'edtUserCode';
    edtUserCode.Left := 3;
    edtUserCode.Top := 29;
    edtUserCode.Width := 121;
    edtUserCode.Height := 22;
    edtUserCode.CharCase := wecUpperCase;
    edtUserCode.Font.Charset := DEFAULT_CHARSET;
    edtUserCode.Font.Color := clWindowText;
    edtUserCode.Font.Height := -13;
    edtUserCode.Font.Name := 'Tahoma';
    edtUserCode.Font.Style := [];
    edtUserCode.HeightStyle := ssAuto;
    edtUserCode.HeightPercent := 100.000000000000000000;
    edtUserCode.MaxLength := 10;
    edtUserCode.ParentFont := False;
    edtUserCode.Text := 'edtUserCode';
    edtUserCode.WidthPercent := 100.000000000000000000;
    edtUserCode.DataField := 'SLNCODE';
    edtUserName.SetParentComponent(WebPanel3);
    edtUserName.Name := 'edtUserName';
    edtUserName.Left := 130;
    edtUserName.Top := 29;
    edtUserName.Width := 367;
    edtUserName.Height := 22;
    edtUserName.ChildOrder := 2;
    edtUserName.Font.Charset := DEFAULT_CHARSET;
    edtUserName.Font.Color := clWindowText;
    edtUserName.Font.Height := -13;
    edtUserName.Font.Name := 'Tahoma';
    edtUserName.Font.Style := [];
    edtUserName.HeightStyle := ssAuto;
    edtUserName.HeightPercent := 100.000000000000000000;
    edtUserName.MaxLength := 10;
    edtUserName.ParentFont := False;
    edtUserName.Text := 'WebDBEdit1';
    edtUserName.WidthPercent := 100.000000000000000000;
    edtUserName.DataField := 'SLNNAME';
    edtPassword.SetParentComponent(WebPanel3);
    edtPassword.Name := 'edtPassword';
    edtPassword.Left := 503;
    edtPassword.Top := 29;
    edtPassword.Width := 121;
    edtPassword.Height := 22;
    edtPassword.ChildOrder := 5;
    edtPassword.Font.Charset := DEFAULT_CHARSET;
    edtPassword.Font.Color := clWindowText;
    edtPassword.Font.Height := -13;
    edtPassword.Font.Name := 'Tahoma';
    edtPassword.Font.Style := [];
    edtPassword.HeightStyle := ssAuto;
    edtPassword.HeightPercent := 100.000000000000000000;
    edtPassword.MaxLength := 10;
    edtPassword.ParentFont := False;
    edtPassword.Text := 'WebDBEdit1';
    edtPassword.WidthPercent := 100.000000000000000000;
    edtPassword.DataField := 'PASSWORD';
    btnGenPassword.SetParentComponent(WebPanel3);
    btnGenPassword.Name := 'btnGenPassword';
    btnGenPassword.Left := 630;
    btnGenPassword.Top := 29;
    btnGenPassword.Width := 91;
    btnGenPassword.Height := 25;
    btnGenPassword.Caption := 'Generate';
    btnGenPassword.Color := clLightseagreen;
    btnGenPassword.ChildOrder := 6;
    btnGenPassword.Font.Charset := DEFAULT_CHARSET;
    btnGenPassword.Font.Color := clWhite;
    btnGenPassword.Font.Height := -13;
    btnGenPassword.Font.Name := 'Tahoma';
    btnGenPassword.Font.Style := [];
    btnGenPassword.HeightStyle := ssAuto;
    btnGenPassword.HeightPercent := 100.000000000000000000;
    btnGenPassword.ParentFont := False;
    btnGenPassword.WidthPercent := 100.000000000000000000;
    SetEvent(btnGenPassword, Self, 'OnClick', 'btnGenPasswordClick');
    btnCopyRights.SetParentComponent(WebPanel3);
    btnCopyRights.Name := 'btnCopyRights';
    btnCopyRights.Left := 503;
    btnCopyRights.Top := 138;
    btnCopyRights.Width := 156;
    btnCopyRights.Height := 25;
    btnCopyRights.Caption := 'Copy Access Rights';
    btnCopyRights.Color := clLightseagreen;
    btnCopyRights.ChildOrder := 6;
    btnCopyRights.Font.Charset := DEFAULT_CHARSET;
    btnCopyRights.Font.Color := clWhite;
    btnCopyRights.Font.Height := -13;
    btnCopyRights.Font.Name := 'Tahoma';
    btnCopyRights.Font.Style := [];
    btnCopyRights.HeightStyle := ssAuto;
    btnCopyRights.HeightPercent := 100.000000000000000000;
    btnCopyRights.ParentFont := False;
    btnCopyRights.WidthPercent := 100.000000000000000000;
    SetEvent(btnCopyRights, Self, 'OnClick', 'btnCopyRightsClick');
    edtCellNo.SetParentComponent(WebPanel3);
    edtCellNo.Name := 'edtCellNo';
    edtCellNo.Left := 3;
    edtCellNo.Top := 101;
    edtCellNo.Width := 121;
    edtCellNo.Height := 22;
    edtCellNo.ChildOrder := 8;
    edtCellNo.Font.Charset := DEFAULT_CHARSET;
    edtCellNo.Font.Color := clWindowText;
    edtCellNo.Font.Height := -13;
    edtCellNo.Font.Name := 'Tahoma';
    edtCellNo.Font.Style := [];
    edtCellNo.HeightStyle := ssAuto;
    edtCellNo.HeightPercent := 100.000000000000000000;
    edtCellNo.MaxLength := 10;
    edtCellNo.ParentFont := False;
    edtCellNo.Text := 'WebDBEdit1';
    edtCellNo.WidthPercent := 100.000000000000000000;
    edtCellNo.DataField := 'cellnumber';
    edtEmail.SetParentComponent(WebPanel3);
    edtEmail.Name := 'edtEmail';
    edtEmail.Left := 130;
    edtEmail.Top := 101;
    edtEmail.Width := 367;
    edtEmail.Height := 22;
    edtEmail.ChildOrder := 2;
    edtEmail.Font.Charset := DEFAULT_CHARSET;
    edtEmail.Font.Color := clWindowText;
    edtEmail.Font.Height := -13;
    edtEmail.Font.Name := 'Tahoma';
    edtEmail.Font.Style := [];
    edtEmail.HeightStyle := ssAuto;
    edtEmail.HeightPercent := 100.000000000000000000;
    edtEmail.MaxLength := 10;
    edtEmail.ParentFont := False;
    edtEmail.Text := 'WebDBEdit1';
    edtEmail.WidthPercent := 100.000000000000000000;
    edtEmail.DataField := 'EMAIL';
    WebDBCheckBox1.SetParentComponent(WebPanel3);
    WebDBCheckBox1.Name := 'WebDBCheckBox1';
    WebDBCheckBox1.Left := 40;
    WebDBCheckBox1.Top := 139;
    WebDBCheckBox1.Width := 281;
    WebDBCheckBox1.Height := 22;
    WebDBCheckBox1.Caption := 'Send Diesel Supplier Balance';
    WebDBCheckBox1.ChildOrder := 12;
    WebDBCheckBox1.Font.Charset := DEFAULT_CHARSET;
    WebDBCheckBox1.Font.Color := clWindowText;
    WebDBCheckBox1.Font.Height := -13;
    WebDBCheckBox1.Font.Name := 'Tahoma';
    WebDBCheckBox1.Font.Style := [];
    WebDBCheckBox1.HeightStyle := ssAuto;
    WebDBCheckBox1.HeightPercent := 100.000000000000000000;
    WebDBCheckBox1.ParentFont := False;
    WebDBCheckBox1.WidthPercent := 100.000000000000000000;
    WebDBCheckBox1.DataField := 'smsdieselerrors';
    WebDBCheckBox1.ValueChecked := 'Y';
    WebDBCheckBox1.ValueUnChecked := 'N';
    wdblSites.SetParentComponent(WebPanel3);
    wdblSites.Name := 'wdblSites';
    wdblSites.Left := 503;
    wdblSites.Top := 101;
    wdblSites.Width := 315;
    wdblSites.Height := 22;
    wdblSites.Font.Charset := DEFAULT_CHARSET;
    wdblSites.Font.Color := clWindowText;
    wdblSites.Font.Height := -13;
    wdblSites.Font.Name := 'Tahoma';
    wdblSites.Font.Style := [];
    wdblSites.HeightPercent := 100.000000000000000000;
    wdblSites.ParentFont := False;
    wdblSites.WidthPercent := 100.000000000000000000;
    wdblSites.DataField := 'SITES';
    wdblSites.KeyField := 'CODE';
    wdblSites.ListField := 'DESCRIPTION';
    wdblSites.ListSource := dsSites;
    WebDBCheckBox2.SetParentComponent(WebPanel3);
    WebDBCheckBox2.Name := 'WebDBCheckBox2';
    WebDBCheckBox2.Left := 388;
    WebDBCheckBox2.Top := 139;
    WebDBCheckBox2.Width := 109;
    WebDBCheckBox2.Height := 22;
    WebDBCheckBox2.Caption := 'Suspend';
    WebDBCheckBox2.ChildOrder := 12;
    WebDBCheckBox2.ElementLabelClassName := 'custom-control-label';
    WebDBCheckBox2.Font.Charset := DEFAULT_CHARSET;
    WebDBCheckBox2.Font.Color := clWindowText;
    WebDBCheckBox2.Font.Height := -13;
    WebDBCheckBox2.Font.Name := 'Tahoma';
    WebDBCheckBox2.Font.Style := [];
    WebDBCheckBox2.HeightStyle := ssAuto;
    WebDBCheckBox2.HeightPercent := 100.000000000000000000;
    WebDBCheckBox2.ParentFont := False;
    WebDBCheckBox2.WidthPercent := 100.000000000000000000;
    WebDBCheckBox2.DataField := 'suspended';
    WebDBCheckBox2.ValueChecked := 'Y';
    WebDBCheckBox2.ValueUnChecked := 'N';
    WebMessageDlg1.SetParentComponent(WebPanel3);
    WebMessageDlg1.Name := 'WebMessageDlg1';
    WebMessageDlg1.Left := 720;
    WebMessageDlg1.Top := 139;
    WebMessageDlg1.Width := 24;
    WebMessageDlg1.Height := 24;
    WebMessageDlg1.Buttons := [];
    WebMessageDlg1.Opacity := 0.200000000000000000;
    WebMessageDlg1.ElementButtonClassName := 'btn';
    WebMessageDlg1.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    WebMessageDlg1.ElementTitleClassName := 'text-body';
    WebMessageDlg1.ElementContentClassName := 'text-body';
    WebSpeedButton1.SetParentComponent(WebPanel3);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 212;
    WebSpeedButton1.Top := 187;
    WebSpeedButton1.Width := 24;
    WebSpeedButton1.Height := 24;
    WebSpeedButton1.Caption := '<<';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.ElementClassName := 'btn btn-light';
    WebSpeedButton1.ElementFont := efCSS;
    WebSpeedButton1.HeightStyle := ssAuto;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 11;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    WebSpeedButton2.SetParentComponent(WebPanel3);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 242;
    WebSpeedButton2.Top := 187;
    WebSpeedButton2.Width := 24;
    WebSpeedButton2.Height := 24;
    WebSpeedButton2.Caption := '<';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.ElementClassName := 'btn btn-light';
    WebSpeedButton2.ElementFont := efCSS;
    WebSpeedButton2.HeightStyle := ssAuto;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 12;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    WebSpeedButton3.SetParentComponent(WebPanel3);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 272;
    WebSpeedButton3.Top := 187;
    WebSpeedButton3.Width := 24;
    WebSpeedButton3.Height := 24;
    WebSpeedButton3.Caption := '>';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.ElementClassName := 'btn btn-light';
    WebSpeedButton3.ElementFont := efCSS;
    WebSpeedButton3.HeightStyle := ssAuto;
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.TabOrder := 13;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton3, Self, 'OnClick', 'WebSpeedButton3Click');
    WebSpeedButton4.SetParentComponent(WebPanel3);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 302;
    WebSpeedButton4.Top := 187;
    WebSpeedButton4.Width := 24;
    WebSpeedButton4.Height := 24;
    WebSpeedButton4.Caption := '>>';
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.ElementClassName := 'btn btn-light';
    WebSpeedButton4.ElementFont := efCSS;
    WebSpeedButton4.HeightStyle := ssAuto;
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.TabOrder := 14;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton4, Self, 'OnClick', 'WebSpeedButton4Click');
    edtSearchAccess.SetParentComponent(WebPanel3);
    edtSearchAccess.Name := 'edtSearchAccess';
    edtSearchAccess.Left := 10;
    edtSearchAccess.Top := 189;
    edtSearchAccess.Width := 189;
    edtSearchAccess.Height := 22;
    edtSearchAccess.ChildOrder := 21;
    edtSearchAccess.ElementClassName := 'form-control';
    edtSearchAccess.ElementFont := efCSS;
    edtSearchAccess.HeightStyle := ssAuto;
    edtSearchAccess.HeightPercent := 100.000000000000000000;
    edtSearchAccess.WidthPercent := 100.000000000000000000;
    SetEvent(edtSearchAccess, Self, 'OnChange', 'edtSearchAccessChange');
    WebScrollBox3.SetParentComponent(WebScrollBox1);
    WebScrollBox3.Name := 'WebScrollBox3';
    WebScrollBox3.Left := 0;
    WebScrollBox3.Top := 217;
    WebScrollBox3.Width := 836;
    WebScrollBox3.Height := 302;
    WebScrollBox3.ElementClassName := 'card';
    WebScrollBox3.Align := alClient;
    WebScrollBox3.BorderStyle := bsSingle;
    WebScrollBox3.ChildOrder := 1;
    TMSFNCDataGrid1.SetParentComponent(WebScrollBox3);
    TMSFNCDataGrid1.Name := 'TMSFNCDataGrid1';
    TMSFNCDataGrid1.Left := 0;
    TMSFNCDataGrid1.Top := 0;
    TMSFNCDataGrid1.Width := 836;
    TMSFNCDataGrid1.Height := 302;
    TMSFNCDataGrid1.Align := alClient;
    TMSFNCDataGrid1.ParentDoubleBuffered := False;
    TMSFNCDataGrid1.DoubleBuffered := True;
    TMSFNCDataGrid1.TabOrder := 0;
    TMSFNCDataGrid1.ShowAcceleratorChar := False;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Height := -12;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Style := [];
    TMSFNCDataGrid1.Adapter := dgdbaUserAccess;
    TMSFNCDataGrid1.BitmapContainer := BitmapContainer1;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Style := [];
    TMSFNCDataGrid1.Columns.Clear;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'UserCode';
      Settings := [gcsReadOnly];
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Right Name';
      Settings := [gcsReadOnly];
      Width := 150.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Access';
      Settings := [gcsType,gcsReadOnly];
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      ReadOnly := True;
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Grant Access';
      Settings := [gcsType,gcsReadOnly];
    end;
    TMSFNCDataGrid1.Designer := False;
    TMSFNCDataGrid1.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.FilterAppearance.Font.Color := clWindowText;
    TMSFNCDataGrid1.FilterAppearance.Font.Height := -12;
    TMSFNCDataGrid1.FilterAppearance.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.FilterAppearance.Font.Style := [];
    TMSFNCDataGrid1.Icons.ExpandIcon.LoadFromFile('settings.useraccesssetup.WebScrollBox3.TMSFNCDataGrid1.Icons.ExpandIcon.svg');
    TMSFNCDataGrid1.Icons.CollapseIcon.LoadFromFile('settings.useraccesssetup.WebScrollBox3.TMSFNCDataGrid1.Icons.CollapseIcon.svg');
    TMSFNCDataGrid1.Icons.FilterIcon.LoadFromFile('settings.useraccesssetup.WebScrollBox3.TMSFNCDataGrid1.Icons.FilterIcon.svg');
    TMSFNCDataGrid1.Icons.FilterActiveIcon.LoadFromFile('settings.useraccesssetup.WebScrollBox3.TMSFNCDataGrid1.Icons.FilterActiveIcon.svg');
    TMSFNCDataGrid1.Icons.FilterClearIcon.LoadFromFile('settings.useraccesssetup.WebScrollBox3.TMSFNCDataGrid1.Icons.FilterClearIcon.svg');
    TMSFNCDataGrid1.Icons.FilterTypeIcon.LoadFromFile('settings.useraccesssetup.WebScrollBox3.TMSFNCDataGrid1.Icons.FilterTypeIcon.svg');
    TMSFNCDataGrid1.Icons.SortAscendingIcon.LoadFromFile('settings.useraccesssetup.WebScrollBox3.TMSFNCDataGrid1.Icons.SortAscendingIcon.svg');
    TMSFNCDataGrid1.Icons.SortDescendingIcon.LoadFromFile('settings.useraccesssetup.WebScrollBox3.TMSFNCDataGrid1.Icons.SortDescendingIcon.svg');
    TMSFNCDataGrid1.Icons.CloseIcon.LoadFromFile('settings.useraccesssetup.WebScrollBox3.TMSFNCDataGrid1.Icons.CloseIcon.svg');
    SetEvent(TMSFNCDataGrid1, Self, 'OnCellClick', 'TMSFNCDataGrid1CellClick');
    SetEvent(TMSFNCDataGrid1, Self, 'OnGetCellProperties', 'TMSFNCDataGrid1GetCellProperties');
    TMSFNCDataGrid1.RowCount := 1;
    dgdbaUserAccess.SetParentComponent(TMSFNCDataGrid1);
    dgdbaUserAccess.Name := 'dgdbaUserAccess';
    dgdbaUserAccess.Left := 328;
    dgdbaUserAccess.Top := 40;
    dgdbaUserAccess.Width := 26;
    dgdbaUserAccess.Height := 26;
    dgdbaUserAccess.Visible := True;
    dgdbaUserAccess.AutoCreateColumns := False;
    dgdbaUserAccess.AutoRemoveColumns := False;
    dgdbaUserAccess.Columns.Clear;
    with dgdbaUserAccess.Columns.Add do
    begin
      FieldName := 'UserCode';
      Header := 'UserCode';
      AutoCreated := False;
    end;
    with dgdbaUserAccess.Columns.Add do
    begin
      FieldName := 'RightName';
      Header := 'Right Name';
      AutoCreated := False;
    end;
    with dgdbaUserAccess.Columns.Add do
    begin
      FieldName := 'Access';
      Header := 'Access';
      AutoCreated := False;
    end;
    with dgdbaUserAccess.Columns.Add do
    begin
      Header := 'Grant Access';
      AutoCreated := False;
    end;
    dgdbaUserAccess.DataSource := dsAccess;
    WebPanel1.SetParentComponent(wpMain);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 836;
    WebPanel1.Height := 33;
    WebPanel1.ElementClassName := 'card';
    WebPanel1.Align := alTop;
    WebPanel1.BorderStyle := bsNone;
    WebPanel1.ChildOrder := 1;
    WebPanel1.ElementBodyClassName := 'card-body';
    WebPanel1.ElementFont := efCSS;
    WebPanel1.Font.Charset := DEFAULT_CHARSET;
    WebPanel1.Font.Color := clWindowText;
    WebPanel1.Font.Height := -13;
    WebPanel1.Font.Name := 'Tahoma';
    WebPanel1.Font.Style := [];
    WebPanel1.ParentFont := False;
    WebPanel1.ShowCaption := False;
    WebPanel1.TabOrder := 1;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 0;
    WebLabel1.Width := 836;
    WebLabel1.Height := 33;
    WebLabel1.Align := alClient;
    WebLabel1.Alignment := taCenter;
    WebLabel1.Caption := 'User Setup';
    WebLabel1.ElementFont := efCSS;
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -16;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.HeightStyle := ssAuto;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    BitmapContainer1.SetParentComponent(WebPanel1);
    BitmapContainer1.Name := 'BitmapContainer1';
    BitmapContainer1.Left := 680;
    BitmapContainer1.Top := 3;
    BitmapContainer1.Width := 26;
    BitmapContainer1.Height := 26;
    BitmapContainer1.Visible := True;
    BitmapContainer1.Items.Clear;
    with BitmapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('settings.useraccesssetup.BitmapContainer1.Items.Bitmap.svg');
      Name := 'green-switch.svg';
      Tag := 0;
    end;
    with BitmapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('settings.useraccesssetup.BitmapContainer1.Items.Bitmap_1.svg');
      Name := 'red-switch.svg';
      Tag := 0;
    end;
    WebPanel2.SetParentComponent(wpMain);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 552;
    WebPanel2.Width := 836;
    WebPanel2.Height := 65;
    WebPanel2.ElementClassName := 'card';
    WebPanel2.Align := alBottom;
    WebPanel2.BorderStyle := bsNone;
    WebPanel2.ChildOrder := 1;
    WebPanel2.ElementBodyClassName := 'card-body';
    WebPanel2.ElementFont := efCSS;
    WebPanel2.ShowCaption := False;
    WebPanel2.TabOrder := 2;
    btnClose.SetParentComponent(WebPanel2);
    btnClose.Name := 'btnClose';
    btnClose.Left := 693;
    btnClose.Top := 6;
    btnClose.Width := 139;
    btnClose.Height := 49;
    btnClose.Caption := 'Close';
    btnClose.Color := clCrimson;
    btnClose.Font.Charset := DEFAULT_CHARSET;
    btnClose.Font.Color := clWhite;
    btnClose.Font.Height := -13;
    btnClose.Font.Name := 'Tahoma';
    btnClose.Font.Style := [];
    btnClose.HeightStyle := ssAuto;
    btnClose.HeightPercent := 100.000000000000000000;
    btnClose.ParentFont := False;
    btnClose.WidthPercent := 100.000000000000000000;
    SetEvent(btnClose, Self, 'OnClick', 'btnCloseClick');
    btnCancel.SetParentComponent(WebPanel2);
    btnCancel.Name := 'btnCancel';
    btnCancel.Left := 503;
    btnCancel.Top := 6;
    btnCancel.Width := 139;
    btnCancel.Height := 49;
    btnCancel.Caption := 'Cancel ';
    btnCancel.Color := clGold;
    btnCancel.ChildOrder := 1;
    btnCancel.Font.Charset := DEFAULT_CHARSET;
    btnCancel.Font.Color := clWindowText;
    btnCancel.Font.Height := -13;
    btnCancel.Font.Name := 'Tahoma';
    btnCancel.Font.Style := [];
    btnCancel.HeightStyle := ssAuto;
    btnCancel.HeightPercent := 100.000000000000000000;
    btnCancel.ParentFont := False;
    btnCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btnCancel, Self, 'OnClick', 'btnCancelClick');
    btnSave.SetParentComponent(WebPanel2);
    btnSave.Name := 'btnSave';
    btnSave.Left := 343;
    btnSave.Top := 6;
    btnSave.Width := 139;
    btnSave.Height := 49;
    btnSave.Caption := 'Save';
    btnSave.Color := clGreen;
    btnSave.ChildOrder := 1;
    btnSave.Font.Charset := DEFAULT_CHARSET;
    btnSave.Font.Color := clWhite;
    btnSave.Font.Height := -13;
    btnSave.Font.Name := 'Tahoma';
    btnSave.Font.Style := [];
    btnSave.HeightStyle := ssAuto;
    btnSave.HeightPercent := 100.000000000000000000;
    btnSave.ParentFont := False;
    btnSave.WidthPercent := 100.000000000000000000;
    SetEvent(btnSave, Self, 'OnClick', 'btnSaveClick');
    wcAccess.SetParentComponent(Self);
    wcAccess.Name := 'wcAccess';
    wcAccess.Connection := dmData.dbConnect;
    wcAccess.Left := 120;
    wcAccess.Top := 282;
    qAccess.SetParentComponent(Self);
    qAccess.Name := 'qAccess';
    qAccess.AfterOpen := qAccessAfterOpen;
    qAccess.Connection := dmData.dbConnect;
    qAccess.Left := 176;
    qAccess.Top := 282;
    qAccessUserCode.SetParentComponent(qAccess);
    qAccessUserCode.Name := 'qAccessUserCode';
    qAccessUserCode.FieldName := 'UserCode';
    qAccessRightName.SetParentComponent(qAccess);
    qAccessRightName.Name := 'qAccessRightName';
    qAccessRightName.FieldName := 'RightName';
    qAccessRightName.Size := 0;
    qAccessAccess.SetParentComponent(qAccess);
    qAccessAccess.Name := 'qAccessAccess';
    qAccessAccess.FieldName := 'Access';
    qAccessModified.SetParentComponent(qAccess);
    qAccessModified.Name := 'qAccessModified';
    qAccessModified.FieldName := 'Modified';
    dsAccess.SetParentComponent(Self);
    dsAccess.Name := 'dsAccess';
    dsAccess.AutoEdit := False;
    dsAccess.DataSet := qAccess;
    dsAccess.Left := 237;
    dsAccess.Top := 281;
    qSites.SetParentComponent(Self);
    qSites.Name := 'qSites';
    qSites.Connection := dmData.dbConnect;
    qSites.QueryString := '$filter=suspended eq '#39'N'#39' & order DESCRIPTION';
    qSites.Left := 609;
    qSites.Top := 89;
    qSitesTemp.SetParentComponent(qSites);
    qSitesTemp.Name := 'qSitesTemp';
    qSitesTemp.FieldName := 'Temp';
    dsSites.SetParentComponent(Self);
    dsSites.Name := 'dsSites';
    dsSites.AutoEdit := False;
    dsSites.DataSet := qSites;
    dsSites.Left := 689;
    dsSites.Top := 90;
    wcUser.SetParentComponent(Self);
    wcUser.Name := 'wcUser';
    wcUser.Connection := dmData.dbConnect;
    wcUser.Left := 96;
    wcUser.Top := 89;
    wdsUser.SetParentComponent(Self);
    wdsUser.Name := 'wdsUser';
    wdsUser.Connection := dmData.dbConnect;
    wdsUser.Left := 176;
    wdsUser.Top := 89;
    wdsUsertemp.SetParentComponent(wdsUser);
    wdsUsertemp.Name := 'wdsUsertemp';
    wdsUsertemp.FieldName := 'temp';
    dsUser.SetParentComponent(Self);
    dsUser.Name := 'dsUser';
    dsUser.Left := 256;
    dsUser.Top := 88;
  finally
    wpMain.AfterLoadDFMValues;
    WebScrollBox1.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    edtUserCode.AfterLoadDFMValues;
    edtUserName.AfterLoadDFMValues;
    edtPassword.AfterLoadDFMValues;
    btnGenPassword.AfterLoadDFMValues;
    btnCopyRights.AfterLoadDFMValues;
    edtCellNo.AfterLoadDFMValues;
    edtEmail.AfterLoadDFMValues;
    WebDBCheckBox1.AfterLoadDFMValues;
    wdblSites.AfterLoadDFMValues;
    WebDBCheckBox2.AfterLoadDFMValues;
    WebMessageDlg1.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    edtSearchAccess.AfterLoadDFMValues;
    WebScrollBox3.AfterLoadDFMValues;
    TMSFNCDataGrid1.AfterLoadDFMValues;
    dgdbaUserAccess.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    BitmapContainer1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    btnClose.AfterLoadDFMValues;
    btnCancel.AfterLoadDFMValues;
    btnSave.AfterLoadDFMValues;
    wcAccess.AfterLoadDFMValues;
    qAccess.AfterLoadDFMValues;
    qAccessUserCode.AfterLoadDFMValues;
    qAccessRightName.AfterLoadDFMValues;
    qAccessAccess.AfterLoadDFMValues;
    qAccessModified.AfterLoadDFMValues;
    dsAccess.AfterLoadDFMValues;
    qSites.AfterLoadDFMValues;
    qSitesTemp.AfterLoadDFMValues;
    dsSites.AfterLoadDFMValues;
    wcUser.AfterLoadDFMValues;
    wdsUser.AfterLoadDFMValues;
    wdsUsertemp.AfterLoadDFMValues;
    dsUser.AfterLoadDFMValues;
  end;
end;

end.